import { FC, JSX } from 'react';
import styles from './Card.css';
import { clsx } from 'clsx';

type CardProps = {
  title: string;
  description: JSX.Element | string;
  image?: JSX.Element;
  theme?: 'default' | 'orange';
};

export const Card: FC<CardProps> = ({ title, description, theme, image }) => (
  <div data-testid="card" className={clsx(styles['container'], theme === 'orange' && styles['container--orange'])}>
    <span className={styles['title']}>{title}</span>
    {image}
    <span className={styles['description']}>{description}</span>
  </div>
);
